import { Button, Card, Flex } from "antd"
import dayjs from "dayjs"
import { ReactComponent as Clock } from "../../../../../assets/images/icon/clock.svg"
import { ReactComponent as Info } from "../../../../../assets/images/icon/info.svg"
import { useNavigate } from "react-router-dom"
import { useMyContext } from "../../../../../entities/context"
import { useEffect, useRef, useState } from "react"
import { deepLinkBridgeElseNewTab } from "../../../../../utils"
import { isIOS } from "react-device-detect"
import { useAllImagesLoaded } from "../../../../../utils/checkImgLoaded"

interface IProps {
    reservationList: Array<IGetMyReservationHistoryResponse>
}

const PendingReservation = ({ reservationList }: IProps) => {
    const navigate = useNavigate();
    const containerRef = useRef<HTMLDivElement>(null);
    const [targetMarginTop, setTargetMarginTop] = useState<number>(0);
    const { topHeight, setMyReservationHistoryTabKey } = useMyContext();
    const { onLoad, allLoaded } = useAllImagesLoaded(reservationList.length);


    useEffect(() => {
        setMyReservationHistoryTabKey(0)
    }, [])

    useEffect(() => {
        if (!containerRef.current) return;
        const targetHeight = containerRef.current.offsetHeight + 24 + 90 + (Number(topHeight) ?? 0);
        const targetValue = window.innerHeight > targetHeight ? window.innerHeight - targetHeight - 28 - (isIOS ? 46 : 20) : 32;
        setTargetMarginTop(targetValue < 0 ? 0 : targetValue)
    }, [reservationList.length, allLoaded])

    return <>
        <div ref={containerRef}>
            {reservationList.length === 0
                ? <div style={{ paddingTop: '75%', textAlign: 'center' }}>
                    <div className="body/b2 secondary/s800">대기중인 프로그램이 없습니다.</div>
                    <div style={{ marginTop: 8 }}>
                        <Button className="sub-title/st2 secondary/s600" style={{ border: '1px solid var(--secondarys400)', borderRadius: '4px' }} color="default" variant="outlined" onClick={() => navigate('/explore')}> 프로그램 둘러보기</Button>
                    </div>
                </div>
                : reservationList.map(reservation =>
                    <Card
                        key={reservation.reservationId}
                        className="custom-card"
                        onClick={() => reservation.isProgram ? navigate(`/program/book/detail/${reservation.reservationId}`) : navigate('/explore')}
                        style={{ width: '100%', marginBottom: 32, border: 'none', boxShadow: '0px 0px 16px 0px #0000001A' }}
                        cover={<img alt="example" src={reservation.imageUrl} style={{ maxHeight: 160, objectFit: 'cover' }} />}
                        onLoad={onLoad}
                    >
                        <div className="sub-title/st4">{reservation.title}</div>
                        <Flex justify="space-between" style={{ marginTop: 20 }}>
                            <div className="secondary/s500">
                                <div>{dayjs(reservation.startDateTime).format('YYYY.MM.DD (dd) HH:mm')}</div>
                                <div>{reservation.yogaCenterName}</div>
                            </div>
                            {reservation.reservationType === "결제 요청"
                                ? <Flex style={{ alignItems: 'center' }} gap={3}>
                                    <Info width={16} height={16} fill="var(--errore600)" />
                                    <div className="sub-title/st1 error/e600">결제 필요</div>
                                </Flex>
                                : reservation.reservationType === "결제 필요" || reservation.reservationType === '예약 대기'
                                    ? <Flex style={{ alignItems: 'center' }} gap={3}>
                                        <Clock />
                                        <div className="sub-title/st1 primary/p800">대기중</div>
                                    </Flex>
                                    : <></>}

                        </Flex>
                    </Card>)}
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: targetMarginTop, paddingBottom: isIOS ? 46 : 20 }}>
            <div className="btn/text-btn secondary/s600" >
                <div>예약 내역이 안보이시나요?</div>
                <div style={{ textDecoration: 'underline', textAlign: 'center' }} onClick={() => deepLinkBridgeElseNewTab('https://pf.kakao.com/_xmWxbYG/chat')}>컨시어지로 문의해주세요.</div>
            </div>
        </div>
    </>
}

export default PendingReservation